import { usePlayroomRewardsTranslations } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ExchangeSuccessful = function ExchangeSuccessful(_ref) {
  var reward = _ref.reward,
    onConfirmed = _ref.onConfirmed;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-text-center",
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://crehana-vercel-images-prd.imgix.net/public/97501387-cee0-4603-8ae4-e1fc73694cad-group-334402.png?auto=format&fit=clip&q=100",
      alt: reward.title,
      className: "tw-object-cover tw-h-6.4 sm:tw-h-9.6 tw-mx-auto tw-mb-3.6",
      loading: "lazy"
    }), /*#__PURE__*/_jsx("h2", {
      className: "tw-font-subtitle2 tw-mb-1.6",
      children: t('PRS_EXCHANGE_SUCCESFUL_TITLE')
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-body4 tw-mb-3.2",
      children: t('PRS_EXCHANGE_SUCCESFUL_DESCRIPTION')
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "tw-btn-primary-s",
      onClick: onConfirmed,
      children: t('PRS_EXCHANGE_SUCCESFUL_OK')
    })]
  });
};
export default ExchangeSuccessful;